import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';

/** Compact table skeleton for import-master-investors modal list. */
const MasterInvestorsModalSkeleton: React.FC = () => (
  <div className="p-3" aria-hidden>
    {Array.from({ length: 6 }).map((_, i) => (
      <div
        key={i}
        className="grid grid-cols-[20px_1fr_1fr_80px] items-center gap-3 border-b border-primary-500/10 px-2 py-2.5 last:border-0"
      >
        <SkeletonBlock className="h-4 w-4 rounded" />
        <SkeletonBlock className="h-3.5 w-3/4" />
        <SkeletonBlock className="h-3.5 w-2/3" />
        <SkeletonBlock className="h-3.5 w-14" />
      </div>
    ))}
  </div>
);

export default MasterInvestorsModalSkeleton;
